<template>
  <li class="pagination-item">
    <span v-if="page === null" class="pagination-item__dots"> ... </span>
    <button
      v-else
      class="pagination-item__page"
      type="button"
      :aria-label="`Перейти к странице ${page}`"
      :class="{ 'pagination-item__page--active': isActive }"
      @click="clickHandler"
    >
      {{ page }}
    </button>
  </li>
</template>

<script lang="ts" setup>
import { computed, defineProps } from "vue";

const props = defineProps({
  page: {
    type: Number,
    default: null,
  },
  current: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(["update"]);

const isActive = computed(() => {
  return props.page === props.current;
});

function clickHandler() {
  emit("update", props.page);
}
</script>

